module.exports = __webpack_public_path__ + "img/loading3.85354bbe.gif";